
// src/web/components/diary-upload-files.jsx

import React from 'react'
import connect from '../../connects/diary-upload-files'
import { themr } from 'react-css-themr'
import diaryTheme from './themes/diary.css'
import {
  CardText,
} from 'react-toolbox/lib/card'
import Avatar from 'react-toolbox/lib/avatar'
import Chip from 'react-toolbox/lib/chip'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import imageChipTheme from './themes/image-chip.css'

@themr('Diary', diaryTheme)
class DiaryUploadFiles extends React.Component {
  render() {
    const {
      t,
      theme,
      uploadFiles,
      uploadVideos,
      cancelUploadFile,
      cancelUploadVideo,
      componentId,
    } = this.props

    if ((!uploadVideos || Object.keys(uploadVideos).length == 0 || _.filter(uploadVideos, (value)=> value).length == 0) &&
        (!uploadFiles  || Object.keys(uploadFiles).length == 0 || _.filter(uploadFiles, (value)=> value).length == 0))
      return null

    return (
      <CardText theme={theme} className="uploads">
        {uploadVideos && Object.keys(uploadVideos).length > 0 &&
          _.map(uploadVideos, (video, key)=>
            video && <Chip key={key} deletable
              onDeleteClick={()=> cancelUploadVideo(key)} >
            <Avatar icon="attachment" />
            {video.isUploading &&
              <ProgressBar type="circular" theme={theme} multicolor
                  mode={video.total && "determinate" || "indeterminate"}
                  value={video.total && video.loaded && video.loaded * 100 / video.total} />}
            {video.item && video.item.name}
          </Chip>
        )}

        {uploadFiles && Object.keys(uploadFiles).length > 0 &&
          _.map(uploadFiles, (file, key)=> {
            if (!file)
              return null
            const thumb_url = file.item && file.item.content_type && file.item.content_type.match(/image/) && file.item.file.thumb_url || undefined
            return (
              <Chip key={key} deletable onDeleteClick={()=> cancelUploadFile(key)} theme={thumb_url && imageChipTheme} >
                {thumb_url && <img className={imageChipTheme.image} src={thumb_url} /> || <Avatar icon="attachment" />}
                {file.isUploading &&
                  <ProgressBar type="circular" theme={theme} multicolor
                      mode={file.total && "determinate" || "indeterminate"}
                      value={file.total && file.loaded && file.loaded * 100 / file.total} />}
                {file.item && file.item.name}
              </Chip>
            )
          }
        )}
      </CardText>
    )
  }
}

export const RawDiaryUploadFiles = DiaryUploadFiles
export default connect(DiaryUploadFiles)



// WEBPACK FOOTER //
// ./src/web/components/diary-upload-files.jsx